export default __webpack_public_path__ + "assets/orange-right-center.svg";